import { LeadFormState } from '@core/Atoms/Pdp/FormState.atom';
import { SearchParamsType } from '@core/Atoms/SearchParams/SearchParams.atom';

import { breadcrumbClickedToEvent } from './Schemas/BreadcrumbClicked/BreadcrumbClickedToEvent';
import { marketingToEvent } from './Schemas/Marketing/MarketingToEvent';
import { userContextToEvent } from './Schemas/UserContext/UserContextToEvent';

export interface BreadcrumbClick {
  searchParams: SearchParamsType;
  userId: string | null | undefined;
  formState: LeadFormState;
  ctaWording: string;
  ctaUrl: string;
  clickPosition: string;
  ctaPosition: number;
}

export function generateBreadcrumbClickedTracking({
  searchParams,
  userId,
  formState,
  ctaWording,
  ctaUrl,
  clickPosition,
  ctaPosition,
}: BreadcrumbClick) {
  const marketingDataObj = {
    marketingValues: { ...(searchParams ?? {}) },
  };

  const userData = {
    userId,
    values: { ...formState },
  };
  const breadcrumbEventObj = {
    clickPosition,
    ctaWording,
    ctaPosition,
    targetUrl: ctaUrl,
  };

  // event actions
  const breadcrumbEvent = breadcrumbClickedToEvent(breadcrumbEventObj);

  // event entities
  const userEvent = userContextToEvent(userData);
  const marketingEvent = marketingToEvent(marketingDataObj);

  const context = [userEvent, marketingEvent];

  return { event: breadcrumbEvent, context };
}
